import { useTranslation } from 'react-i18next';
import React,{useContext, useEffect} from "react";
import TopSearch from '@/components/TopSearch'
import {useContractModel} from '../contractParticularsModel'
import { getPcodeDict } from "@/utils/dataStorage"
import { MyContext } from '@/store/myContext'
import { commonService } from "@/erp_subpackage/pages/common/commonService";
import { getBussinessEntityList } from '@/service/dataService'
export function PageHeader(){
    const {t} = useTranslation()
    const {searchParam,setSearchParam,loadData,} =useContractModel() 
    const {  Option, } = useContext(MyContext)
    useEffect(() => {
        console.log(111)
        console.log(t(`contractManagement.view.PageHeader.车辆牌照`))
        console.log(t(`aiDiagnose.details.请输入故障口语`))
    },[])
    const searchList = {
        normalList: [
            {
                type: 'input',
                placeholder:  t(`contractManagement.view.PageHeader.车辆牌照`),
                valueName: 'vehicleCode',
            },
            {
                type: "input",
                placeholder:  t(`contractManagement.view.PageHeader.客户名称`),
                valueName: 'customerName',
            },
            {
                type: "input",
                placeholder:  t(`contractManagement.view.PageHeader.单据编号`),
                valueName: 'orderCode',
            },
            {
                type: "select",
                placeholder:  t(`contractManagement.view.PageHeader.签约类型`),
                valueName: 'signType',
                optionList: () =>
                getPcodeDict('046').children.map((item) => (
                    <Option value={item.dictCode} key={item.id}>
                        {item.title}
                    </Option>
                )),
            },
            {
                type: "select",
                placeholder:  t(`contractManagement.view.PageHeader.大包模式`),
                valueName: 'bigBagMode',
                optionList: () =>
                getPcodeDict('047').children.map((item) => (
                    <Option value={item.dictCode} key={item.id}>
                        {item.title}
                    </Option>
                )),
            },
            {
                type: "searchSelect",
                placeholder:  t(`contractManagement.view.PageHeader.签约实体`),
                valueName: 'signBusinessEntityId',
                optionName: "entityName",
                searchItemName: "entityName",
                optionId: "id",
                searchApi:getBussinessEntityList,
                
                
            },
            
           
        ],
        hideList: [
            {
                type: "searchSelect",
                placeholder:  t(`contractManagement.view.PageHeader.签约机构`),
                valueName: 'signOrganId',
                optionName: "organName",
                searchItemName: "organName",
                optionId: "id",
                searchApi: commonService.orgPageList
            },
        ]
    }
       
       
    

    return (
        <TopSearch
            title= { t(`contractManagement.view.PageHeader.合约管理`)}
            searchValue={searchParam}
            justify="start"
            searchListData={searchList}
            setSearchValue={(obj) => setSearchParam(obj)}
            handleSearch={loadData}
            
            
        />
    )
}